import { render } from "./Kitchenanddining.vue?vue&type=template&id=59b69a88"
import script from "./Kitchenanddining.vue?vue&type=script&lang=js"
export * from "./Kitchenanddining.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__